import ProgressBar from 'components/ProgressBar';

import useProgressSidebar from './useProgressSidebar';

const ProgressSidebar: React.FunctionComponent = function () {
  const { items, isLoading } = useProgressSidebar();
  return (
    <div className="flex flex-col p-4 w-[220px] xl:w-64">
      <div className="sticky top-[120px]">
        <ProgressBar items={items} lastPassed isLoading={isLoading} />
      </div>
    </div>
  );
};

export default ProgressSidebar;
